export default "__VITE_ASSET__LN0tkoPJ__"